export default __webpack_public_path__ + "static/logowhite-395e2d2a43007af7ce24c69e64a2c9a2.svg";